define('lq/events/actions/exportCommand',["lq/events/actions/eventAction", "jquery", "lq", "when"], function (EventAction, $, lq, when) {
    "use strict";

    var pollDelayInMilliseconds = 1000;

    function ExportCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ExportCommand, EventAction);

    ExportCommand.typeName = 'ExportCommand';

    ExportCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ExportCommand.prototype.execute = function (continuation) {
        var self = this;
        this.continuation = continuation;
        this.piping.dispatcher
            .dispatchToAbsoluteUrl(this.getExportUrl(), this.getDispatchData())
            .then(function (response) {
                if (response.ticketNumber) self.handleExport(response.ticketNumber);
            })
            .catch(function () {
                alert("Something went wrong while exporting.");
            });
    };

    ExportCommand.prototype.getExportUrl = function () {
        return this.piping.url.prepare(lq.getTenantUrl("Export"));
    };

    ExportCommand.prototype.getDispatchData = function () {
        return {
            actionId: this.piping.actionId,
            globalParameters: this.piping.parameters.globals.getAll(),
            localParameters: this.piping.parameters.locals.getAll(),
            commandId: this.eventData.command,
        };
    };

    ExportCommand.prototype.handleExport = function (ticketNumber) {
        var self = this;
        return when.promise(function (resolve) {
            self.poll(resolve, ticketNumber);
        });
    };

    ExportCommand.prototype.poll = function (resolve, ticketNumber) {
        var self = this;
        setTimeout(function () {
            resolve(
                self.isReady(ticketNumber).always(function (data, _textStatus, xhr) {
                    self.handleStatus(xhr.status, ticketNumber, data);
                })
            );
        }, pollDelayInMilliseconds);
    };

    ExportCommand.prototype.isReady = function (ticketNumber) {
        return $.get({
            url: lq.getTenantUrl("Export/IsReady"),
            data: { ticketNumber: ticketNumber },
            cache: false,
        });
    };

    ExportCommand.prototype.handleStatus = function (status, ticketNumber, data) {
        if (status === 202) {
            return this.handleExport(ticketNumber, this.isReady);
        } else if (status === 200) {
            this.finishExport(ticketNumber, data);
        }
    };

    ExportCommand.prototype.finishExport = function (ticketNumber, data) {
        if (data.isDirty) {
            this.handleExecutionTrailDirty(continuation);
        } else {
            this.setParameters(data);
            this.downloadExportedFile(ticketNumber, data);
        }
    };

    ExportCommand.prototype.downloadExportedFile = function (ticketNumber, data) {
        if (!data || !data.download) {
            this.continuation();
            return;
        }
        if (data.url) {
            window.location = this.piping.url.prepare(lq.getTenantUrl("DynamicContent/DownloadFile"), {
                filename: data.filename,
                url: data.url,
                openInBrowser: false,
            });
        } else {
            window.location = this.piping.url.prepare(lq.getTenantUrl("Export/Download"), {
                ticketNumber: ticketNumber,
            });
        }
        this.continuation();
    };

    ExportCommand.prototype.setParameters = function (data) {
        if (data.entityIdParameter) {
            this.piping.parameters.globals.setValue(data.entityIdParameter, data.entityIdValue);
        }
    };

    return ExportCommand;
});

